module.exports = __webpack_public_path__ + "img/STORJ.b6af35ca.svg";